import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from 'gatsby-link';
import { ChevronDown, MoreVertical } from 'react-feather';
import config from '../config';
import { getPageTree } from '../utils/contentful';
import styles from './NavBar.module.scss';

export default class NavBar extends Component {
  static propTypes = {
    pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  };

  state = {
    expanded: false,
    pages: [],
  };

  componentWillMount() {
    const indexPage = getPageTree(this.props.pages);
    this.setState({ pages: [indexPage, ...indexPage.subpages] })
  }

  toggle = () => {
    this.setState(state => ({
      expanded: !state.expanded,
    }));
  };

  render() {
    const { expanded } = this.state;
    const { indexSlug } = config.nav;

    return (
      <nav className={styles.navBar}>
        <ul className={classnames(styles.nav, expanded && styles.navExpanded)} onClick={this.toggle}>
          {this.state.pages.map(({ title, slug, path, subpages }) => (
            <li key={path} className={styles.navItem}>
              <Link
                className={styles.navLink}
                activeClassName={styles.navLinkActive}
                exact={slug === indexSlug}
                to={path}
              >
                {title}
                {(slug !== indexSlug && !!subpages.length) && (
                  <ChevronDown />
                )}
              </Link>
              {(slug !== indexSlug && !!subpages.length) && (
                <ul className={styles.subNav}>
                  {subpages.map(({ title, path }) => (
                    <li key={path} className={styles.subNavItem}>
                      <Link
                        className={styles.subNavLink}
                        activeClassName={styles.navLinkActive}
                        to={path}
                      >
                        {title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        <button className={styles.toggleButton} onClick={this.toggle}>
          <MoreVertical />
        </button>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar.js